module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_04_off.f36ddbee.svg";